import { Component, OnInit, Input, HostListener, ViewChild, ElementRef, OnDestroy, AfterContentInit, AfterViewInit, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { ModalServiceService } from '@app/feature/main/roles-shared/services/modal-service.service';
import { MarketDataDetailsService } from '@app/feature/main/roles-shared/services/market-data-details.service';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import { MarketData, AdminFilteredData, MarketDataChartJSON } from '@app/feature/main/roles-shared/models/marketDataModel';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { MarketDataChartGeneratorService } from '@app/feature/main/roles-shared/services/market-data-chart-generator.service';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-market-data-filter',
  templateUrl: './market-data-filter.component.html',
  styleUrls: ['./market-data-filter.component.css']
})
export class MarketDataFilterComponent implements OnInit, AfterViewInit {
  isOpen: boolean = false;
  noFilterDataFlag: boolean = false;
  bookmarkedGraphTechDomain: string;

  @ViewChild('myModal') modal: ElementRef;
  @Input() closebtn: boolean;
  @Input() modalId: string;
  @Input() modalTitle: string;
  @Input() blocking: boolean;
  @Input() researchDocumentId: string;
  @Output() chartData = new EventEmitter<any>();

  dataSubscriptionService: Subscription;
  filterDataSubcriptionService: Subscription;
  modalStatusService: Subscription;

  marketDataContent: any = new MarketData();
  marketDat: any = {
    ChartJSON: {
    }
  };
  marketDats: any = {
    ChartJSON: {
    }
  };

  // marketDat: MarketDataChartJSON = new MarketDataChartJSON(); // get from market data service
  userFilterList: any = {}; // list of filters that can be applied
  userFilterListClone: any = {}; // user filter list cloned to reset filter once modal is closed
  userAppliedFilterList: any = {}; // filters applied by user

  private adminFilteredData: any = new AdminFilteredData(); // list of filters applied by admin
  private adminFilteredDataClone: any;
  private userFilteredData = new MarketData(); // final filter model
  marketDataId: string;
  solution: any;
  highChartSubscrition: any;
  hasSolutionFilter: boolean;
  isParentQuestionGraph: boolean;
  roleStatus : boolean;
  userDetailsObject;
  vendorRole:string;
  solutionCheckDataflag: boolean;
  customQuestionCheckFlag: boolean;

  constructor(private modalService: ModalServiceService,
    private marketDataDetailsService: MarketDataDetailsService,
    private rolesSharedService: RolesSharedService,
    private marketDataChartGenerator: MarketDataChartGeneratorService,
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getUserRole();
    this.marketDataId = this.route.snapshot.paramMap.get("marketDataId");
    this.marketDats = this.route.snapshot.data.marketData;
    this.hasSolutionFilter = this.marketDats? this.marketDats.hasSolutionFilter : false;
    this.isParentQuestionGraph = this.marketDats? this.marketDats.isParentQuestionGraph : false;
    this.marketDats.numberOfResponse = null;
    const solutionFilter = {
      techDomainId: this.route.queryParams['value'].bookmarkedTechDomain
      // techDomainId: sessionStorage.getItem('bookmarkedTechDomain')
    };
    this.rolesSharedService.getSolutionFilter(solutionFilter).subscribe((response)=>{
      this.solution = response['data'];
      this.marketDats.userFilters.solution = this.solution;
      sessionStorage.setItem("bookmarkedSolution", JSON.stringify(response['data']));
    });
  }

  ngAfterViewInit() {
    // this.marketDat = this.marketDataDetailsService.getMarketData();
    this.marketDat = this.marketDats;
    this.marketDataContent = this.marketDat.content;
    setTimeout(() => {
      this.userFilterList = this.marketDataDetailsService.populateMarketDataFilterSelection(
        this.marketDat.userFilters, this.marketDat.userFilteredData
      );
    }, 1000);
    this.userFilteredData = this.marketDat.userFilteredData;
  }
  solutionSelection(subTechDomainId: string, index, event){
    if (! this.userFilteredData['subTechDomainId']) {
      this.userFilteredData['subTechDomainId'] = [];
    }
    if (! this.userFilterList['solutions']) {
      this.userFilterList['solutions'] = this.solution;
    }
    if (event.srcElement.checked) {
      this.userFilteredData['subTechDomainId'].push(subTechDomainId);
      this.userFilterList.solutions[index].status = true;
      if(this.userFilteredData['subTechDomainId'].length != 0){
        this.solutionCheckDataflag = true;
        this.customQuestionCheckFlag = this.customQuestionCheckFlag? this.customQuestionCheckFlag : false;
        // this.solutionCheckDataflag=true;
      }
    } else if (_.includes(this.userFilteredData['subTechDomainId'], subTechDomainId)) {
      _.pull(this.userFilteredData['subTechDomainId'], subTechDomainId);
      this.userFilterList.solutions[index].status = false;
      if(this.userFilteredData['subTechDomainId'].length == 0){
        // this.solutionCheckDataflag=false;
        this.solutionCheckDataflag = false;
      }
    }
  }
  countrySelection(countryId: string, index, event) {
    if (event.srcElement.checked) {
      this.userFilteredData.countryId.push(countryId);
      this.userFilterList.country[index].status = true;
    } else if (_.includes(this.userFilteredData.countryId, countryId)) {
      _.pull(this.userFilteredData.countryId, countryId);
      this.userFilterList.country[index].status = false;
    }
  }

  employeeSizeSelection(employeeSizeId, index, event) {
    if (event.srcElement.checked) {
      this.userFilteredData.employeeSizeId.push(employeeSizeId);
      this.userFilterList.employeeSize[index].status = true;
    } else if (_.includes(this.userFilteredData.employeeSizeId, employeeSizeId)) {
      _.pull(this.userFilteredData.employeeSizeId, employeeSizeId);
      this.userFilterList.employeeSize[index].status = false;
    }
  }

  geographySelection(geographyId, index, event) {
    if (event.srcElement.checked) {
      this.userFilteredData.geographyId.push(geographyId);
      this.userFilterList.geography[index].status = true;
    } else if (_.includes(this.userFilteredData.geographyId, geographyId)) {
      _.pull(this.userFilteredData.geographyId, geographyId);
      this.userFilterList.geography[index].status = false;
    }
  }

  industrySelection(industryId, index, event) {
    if (event.srcElement.checked) {
      this.userFilteredData.industryId.push(industryId);
      this.userFilterList.industry[index].status = true;
    } else if (_.includes(this.userFilteredData.industryId, industryId)) {
      _.pull(this.userFilteredData.industryId, industryId);
      this.userFilterList.industry[index].status = false;
    }
  }

  itBudgetSelection(itBudgetId, index, event) {
    if (event.srcElement.checked) {
      this.userFilteredData.itBudgetId.push(itBudgetId);
      this.userFilterList.itBudget[index].status = true;
    } else if (_.includes(this.userFilteredData.itBudgetId, itBudgetId)) {
      _.pull(this.userFilteredData.itBudgetId, itBudgetId);
      this.userFilterList.itBudget[index].status = false;
    }
  }

  jobTitleSelection(jobTitleId, index, event) {
    if (event.srcElement.checked) {
      this.userFilteredData.jobTitleId.push(jobTitleId);
      this.userFilterList.jobTitle[index].status = true;
    } else if (_.includes(this.userFilteredData.jobTitleId, jobTitleId)) {
      _.pull(this.userFilteredData.jobTitleId, jobTitleId);
      this.userFilterList.jobTitle[index].status = false;
    }
  }

  lineOfBusinessSelection(lineOfBusinessId, index, event) {
    if (event.srcElement.checked) {
      this.userFilteredData.lineOfBusinessId.push(lineOfBusinessId);
      this.userFilterList.lineOfBusiness[index].status = true;
    } else if (_.includes(this.userFilteredData.lineOfBusinessId, lineOfBusinessId)) {
      _.pull(this.userFilteredData.lineOfBusinessId, lineOfBusinessId);
      this.userFilterList.lineOfBusiness[index].status = false;
    }
  }

  revenueSelection(revenueId, index, event) {
    if (event.srcElement.checked) {
      this.userFilteredData.globalRevenueId.push(revenueId);
      this.userFilterList.revenue[index].status = true;
    } else if (_.includes(this.userFilteredData.globalRevenueId, revenueId)) {
      _.pull(this.userFilteredData.globalRevenueId, revenueId);
      this.userFilterList.revenue[index].status = false;
    }
  }

  filterApply() {
    for (let key in this.userFilteredData) {
      this.marketDataContent[key] = this.userFilteredData[key];
    }
    this.saveMarketDataWithAppliedFilters();
  }

  resetFilter() {
    this.userFilterList = this.marketDataDetailsService.resetMarketDataFilterSelection(this.userFilterList);
    for (let key in this.userFilteredData) {
      this.marketDataContent[key] = [...[]];
      this.userFilteredData[key] = [...[]];
    }
    this.marketDataDetailsService.marketData(this.marketDat);

    // this.highChartSubscrition = this.marketDataChartGenerator
    //     .generateChartJSON(this.marketDat)
    //     .subscribe((chartJSON: any) => {
    //       this.marketDat.ChartJSON = chartJSON;
    //       this.ref.detectChanges();
    //     });
  }

  saveMarketDataWithAppliedFilters() {
    this.marketDat.userFilterList = this.userFilterList;
    this.marketDat.userFilteredData = this.userFilteredData;
    this.marketDat.userAppliedFilterList = this.userAppliedFilterList;
    // Public changes to market data subscriber
    this.marketDataDetailsService.marketData(this.marketDat);
  }
  getUserRole(){
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.vendorRole = this.userDetailsObject.roles[0].code;
    }
    if(this.vendorRole== 'tech_vendor' || this.vendorRole == 'tech_analyst' || this.vendorRole == 'ecosystm_staff'){
      this.roleStatus=true;
    }
  }

}






// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/market-data-filter/market-data-filter.component.ts